export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_13.b92406fa.jpg";